// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LoadingComponent.css */
.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background-color: #F8F9FA;
    text-align: center;
  }
  
  .loading-container h1 {
    margin: 0;
    font-size: 24px;
    color: #223263;
  }
  
  .loading-container p {
    margin: 10px 0;
    font-size: 16px;
    color: #525252;
  }
  
  .bubbles {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }
  
  .bubble {
    width: 12px;
    height: 12px;
    margin: 0 5px;
    border-radius: 50%;
    background-color: #223263;
    animation: bubbleAnimation 1.2s infinite ease-in-out;
  }
  
  @keyframes bubbleAnimation {
    0%, 80%, 100% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
  }
  
  .bubble:nth-child(2) {
    animation-delay: -0.4s;
  }
  
  .bubble:nth-child(3) {
    animation-delay: -0.2s;
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/Loading.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,oDAAoD;EACtD;;EAEA;IACE;MACE,mBAAmB;IACrB;IACA;MACE,mBAAmB;IACrB;EACF;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB","sourcesContent":["/* LoadingComponent.css */\n.loading-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n    background-color: #F8F9FA;\n    text-align: center;\n  }\n  \n  .loading-container h1 {\n    margin: 0;\n    font-size: 24px;\n    color: #223263;\n  }\n  \n  .loading-container p {\n    margin: 10px 0;\n    font-size: 16px;\n    color: #525252;\n  }\n  \n  .bubbles {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 20px;\n  }\n  \n  .bubble {\n    width: 12px;\n    height: 12px;\n    margin: 0 5px;\n    border-radius: 50%;\n    background-color: #223263;\n    animation: bubbleAnimation 1.2s infinite ease-in-out;\n  }\n  \n  @keyframes bubbleAnimation {\n    0%, 80%, 100% {\n      transform: scale(0);\n    }\n    40% {\n      transform: scale(1);\n    }\n  }\n  \n  .bubble:nth-child(2) {\n    animation-delay: -0.4s;\n  }\n  \n  .bubble:nth-child(3) {\n    animation-delay: -0.2s;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
